import type { UserFeatures } from '@chatsdet/types';

/** Mirrors the API gate `isVisualComparisonEnabled`: `sandbox-v2` and `sandbox-v2.visual-comparison`. */
export function isVisualNavVisible(features: UserFeatures | undefined): boolean {
  return Boolean(features?.sandboxV2 && features.sandboxV2VisualComparison);
}

/** Mirrors the API gate `isSandboxV2Enabled`: a perf run is two sandbox claims. */
export function isPerformanceNavVisible(features: UserFeatures | undefined): boolean {
  return Boolean(features?.sandboxV2);
}
